/**
 * Cognito groups allowed to create casino accounts (Add Casino Account).
 * Keep in sync with services/ms-auth and ms-casino userFlagHelper
 * CREATE_CASINO_ACCOUNT_GROUPS / canCreateCasinoAccount.
 * EurekaAdmin kept for SideMenu parity; Eureka casino is removed.
 */
export const CREATE_CASINO_ACCOUNT_GROUPS: readonly string[] = [
  'SlotcheckInternal',
  'LOTCAdmin',
  'EurekaAdmin',
];

/** True when cognito:groups includes any Create Casino Account admin group. */
export function canCreateCasinoAccount(groups: string[] = []): boolean {
  if (!Array.isArray(groups) || groups.length === 0) return false;
  return CREATE_CASINO_ACCOUNT_GROUPS.some((group) => groups.includes(group));
}
